exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2R54KXrJ9SazSNx_pFGxE5{white-space:nowrap}html[dir] ._2R54KXrJ9SazSNx_pFGxE5{padding:5px 15px;margin:0}.ToIDff3kNQIFXsp5vDul9{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"toggle": "_2R54KXrJ9SazSNx_pFGxE5",
	"container": "ToIDff3kNQIFXsp5vDul9"
};